<template>
  <v-sheet v-if="$store.state.isUserLoggedIn" :rounded="isSmallerDisplay() ? '' : 'lg'" class="pa-2">
    <v-card>
      <v-card-text class="pa-1">
        <iframe class="agreement_iframe" id="scroll-target" :src="url"></iframe>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <GoBackButton :text= "$t('message.back')" color="secondary"/>
      </v-card-actions>
    </v-card>
  </v-sheet>
</template>
<script>

import GoBackButton from '@/components/inputs/GoBackButton.vue';

export default {
  data() {
    return {
      url: "https://www.bjjlink.com/privacy-policy",
    };
  },
  components: {
    GoBackButton,
  },
  async created() {
  },
  methods: {
  },
};
</script>

<style scoped>
.agreement_iframe {
  width: 100%;
  height: 400px;
}
</style>
